import React from "react";
import exportFromJSON from "export-from-json";

const ExportDropdown = ({
  data = [],
  columns = [],
  reportName = "Custom Report",
  disabled = false,
}) => {
  const handleExportCsv = () => {
    if (data.length === 0) return;
    exportFromJSON({
      data,
      fileName: reportName,
      exportType: exportFromJSON.types.csv,
    });
  };

  return (
    <button
      onClick={handleExportCsv}
      disabled={disabled || data.length === 0}
      className={`flex items-center gap-2 px-4 py-2 text-xs fw_500 rounded-md border border-D0D5DD ${
        disabled || data.length === 0
          ? "bg-F4F4F4 text-667085 cursor-not-allowed"
          : "bg-white text-344054 hover:bg-f3f8ff"
      }`}
    >
      Export CSV
    </button>
  );
};

export default ExportDropdown;
